import { request } from "./client";
import type {
  ObservationsShadowResponse,
  ProjectHoursResponse,
  TimeDaysResponse,
  TimelineQuery,
  TimelineResponse,
  UnassignedTimeResponse,
} from "./types";

/** GET /api/v1/tawa/workers/timeline?worker_url=&from=&to=&limit=. */
export async function getWorkerTimeline(
  q: TimelineQuery,
): Promise<TimelineResponse> {
  const params: Record<string, string | number> = { worker_url: q.worker_url };
  if (q.from) params.from = q.from;
  if (q.to) params.to = q.to;
  if (typeof q.limit === "number") params.limit = q.limit;
  return request<TimelineResponse>({
    method: "GET",
    url: "/workers/timeline",
    params,
  });
}

/** GET /api/v1/tawa/workers/time-days?worker_url=&from=&to= (jours YYYY-MM-DD). */
export async function getWorkerTimeDays(q: {
  worker_url: string;
  from: string;
  to: string;
}): Promise<TimeDaysResponse> {
  return request<TimeDaysResponse>({
    method: "GET",
    url: "/workers/time-days",
    params: q,
  });
}

/** GET /api/v1/tawa/workers/observations/shadow?worker_url=&from=&to=. */
export async function getObservationsShadow(q: {
  worker_url: string;
  from: string;
  to: string;
}): Promise<ObservationsShadowResponse> {
  return request<ObservationsShadowResponse>({
    method: "GET",
    url: "/workers/observations/shadow",
    params: q,
  });
}

/** GET /api/v1/tawa/workers/unassigned-time?worker_url=&from=&to= : 1095 jours
 * au plus après `from`, bornes incluses. */
export async function getWorkerUnassignedTime(q: {
  worker_url: string;
  from: string;
  to: string;
}): Promise<UnassignedTimeResponse> {
  return request<UnassignedTimeResponse>({
    method: "GET",
    url: "/workers/unassigned-time",
    params: q,
  });
}

/** GET /api/v1/tawa/workers/project-hours?worker_url=&from=&to= : temps par
 * projet et élément de travail, 1095 jours au plus après `from`, bornes
 * incluses. */
export async function getWorkerProjectHours(q: {
  worker_url: string;
  from: string;
  to: string;
}): Promise<ProjectHoursResponse> {
  return request<ProjectHoursResponse>({
    method: "GET",
    url: "/workers/project-hours",
    params: q,
  });
}
